import type { CanadaGapEntryIssue } from '../lib/types'

/** One timeline entry's CanadaGAP gaps (amber) and violations (red), or nothing when it is complete. */
export function EntryIssues({ issue }: { issue: CanadaGapEntryIssue | undefined }) {
  if (!issue) return null
  return (
    <div className="mt-1 space-y-0.5">
      {issue.violations.map((v, i) => (
        <p key={i} className="text-xs text-red-600 dark:text-red-400">
          ⚠ {v.message}
        </p>
      ))}
      {issue.missing.length > 0 && (
        <p className="text-xs text-amber-600 dark:text-amber-400">Missing for CanadaGAP: {issue.missing.join(', ')}</p>
      )}
    </div>
  )
}
